import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, watch_id, type_id, alert_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/notifications/?size=${size}`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/notifications.js